import { useState, useEffect } from 'react'
import { getTrainingListPositionAPI } from '../services/certificate'

function UsePosition() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTrainingListPositionAPI()
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return { value: d.id, label: d.t_position }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UsePosition
